export function Modern({
    inputData,
}) {
    return (
        <div className="invitation" id="invitation-print-area">
            <div className={`invite-card-${inputData.theme}`}>
                <div className="image-header"></div>

                <div className="content">
                    <h1>{inputData.title}</h1>
                    <div className="name">{inputData.event}</div>

                    <div className={`invite-details-${inputData.theme}`}>
                        <p><span>Date:</span> {new Date(inputData.date).toDateString()}</p>
                        <p><span>Time:</span> {inputData.time}</p>
                        <p><span>Venue:</span> {inputData.venue}</p>
                    </div>
                    <footer>{inputData.footer}</footer>
                </div>
            </div>
        </div>
    );
}
